export const productDynamicAttributes = () => {
	const bemBlock = 'product-dynamic-attributes';

	const dynamicAttributesContainer = document.querySelector(
		'#productDynamicAttributes',
	);

	if (!dynamicAttributesContainer) return;

	const dynamicAttributesList = dynamicAttributesContainer.querySelector(
		`.${bemBlock}__list`,
	);
	const dynamicAttributes = dynamicAttributesContainer.querySelectorAll(
		`.${bemBlock}__list-item`,
	);
	const dynamicAttributesShowMoreLessBtn =
		dynamicAttributesContainer.querySelector(`.${bemBlock}__toggle`);

	if (dynamicAttributesShowMoreLessBtn) {
		const showMoreText =
			dynamicAttributesShowMoreLessBtn.getAttribute('data-show-more');
		const showLessText =
			dynamicAttributesShowMoreLessBtn.getAttribute('data-show-less');

		dynamicAttributesShowMoreLessBtn.addEventListener('click', () => {
			const isCollapsed = dynamicAttributesList?.classList.contains(
				`${bemBlock}__list--fade`,
			);

			dynamicAttributesShowMoreLessBtn.classList.toggle(
				`${bemBlock}__toggle--show-more`,
			);
			dynamicAttributesShowMoreLessBtn.classList.toggle(
				`${bemBlock}__toggle--show-less`,
			);
			dynamicAttributesShowMoreLessBtn.textContent = isCollapsed
				? showLessText
				: showMoreText;
			dynamicAttributesList?.classList.toggle(`${bemBlock}__list--fade`);

			dynamicAttributes?.forEach((attribute, idx) => {
				attribute.classList.toggle('d-none', !isCollapsed && idx > 3);
			});
		});
	}
};
